__turbopack_context__.v({
  "alchemySymbol": "cardName-module-scss-module__BjuXyq__alchemySymbol",
});
